<div class="w-full bg-white min-h-[5rem] border-b flex items-center justify-between px-3 sm:px-4 lg:px-8 py-2 sm:py-0">

  <!-- LEFT -->
  <div class="flex items-center gap-2 sm:gap-4">

    <!-- Botão Hamburger (apenas mobile < md) -->
    <button 
      (click)="onOpenMobileSidebar()"
      class="md:hidden p-2 hover:bg-gray-100 rounded-lg"
    >
      <svg class="w-6 h-6 text-westetics-neutral-800" viewBox="0 0 24 24" fill="currentColor">
        <path d="M3 18H21V16H3V18ZM3 13H21V11H3V13ZM3 6V8H21V6H3Z"/>
      </svg>
    </button>

    <!-- Ícone circular (somente subrota) - escondido em mobile -->
    <div
      *ngIf="breadcrumbs.length > 1"
      class="hidden sm:flex w-10 h-10 sm:w-12 sm:h-12 rounded-full border border-neutral-300 items-center justify-center"
    >
      <span
        class="w-4 h-4 sm:w-[18px] sm:h-[18px] text-current"
        [innerHTML]="selectedIconSvg || ''"
      ></span>
    </div>

    <!-- Breadcrumb -->
    <div class="flex flex-col leading-tight">
      <p class="text-base sm:text-sm font-medium text-westetics-neutral-900">
        {{ breadcrumbs[0] }}
      </p>

      <p
        *ngIf="breadcrumbs.length > 1"
        class="text-sm sm:text-lg font-medium text-neutral-950 line-clamp-1"
      >
        {{ breadcrumbs[1] }}
      </p>
    </div>

  </div>

  <!-- RIGHT -->
  <div class="flex items-center gap-2 sm:gap-4">

    <!-- Search Desktop (sm+) -->
    <div class="relative hidden sm:block" *ngIf="showSearchField">
      <input
        #searchInput
        type="text"
        placeholder="Pesquisar..."
        [(ngModel)]="searchInputValue"
        [ngClass]="{
          'w-0 pl-0 border-transparent': !showSearch,
          'w-40 md:w-80 pl-10 border border-neutral-300': showSearch
        }"
        class="transition-all duration-300 ease-in-out rounded-lg h-10 focus:outline-none"
        (focus)="showSearch = true"
        (blur)="!searchInputValue && showSearch && (showSearch = false)"
        (input)="onSearchInput($event)"
      />

      <button
        type="button"
        (click)="toggleSearch()"
        [ngClass]="{
          'absolute left-2 top-1/2 -translate-y-1/2 text-neutral-500 hover:text-neutral-700': showSearch,
          'relative p-2 text-neutral-500 hover:text-neutral-700': !showSearch
        }"
      >
        <svg class="w-5 h-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
          <path d="M9.25 2.5C12.976 2.5 16 5.524 16 9.25C16 12.976 12.976 16 9.25 16C5.524 16 2.5 12.976 2.5 9.25C2.5 5.524 5.524 2.5 9.25 2.5ZM9.25 14.5C12.1502 14.5 14.5 12.1502 14.5 9.25C14.5 6.349 12.1502 4 9.25 4C6.349 4 4 6.349 4 9.25C4 12.1502 6.349 14.5 9.25 14.5ZM15.6137 14.5532L17.7355 16.6742L16.6742 17.7355L14.5532 15.6137L15.6137 14.5532Z"/>
        </svg>
      </button>
    </div>

    <!-- Search Mobile (apenas ícone) -->
    <button
      *ngIf="showSearchField"
      type="button"
      (click)="toggleMobileSearch()"
      class="sm:hidden p-2 text-neutral-500 hover:text-neutral-700"
    >
      <svg class="w-5 h-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
        <path d="M9.25 2.5C12.976 2.5 16 5.524 16 9.25C16 12.976 12.976 16 9.25 16C5.524 16 2.5 12.976 2.5 9.25C2.5 5.524 5.524 2.5 9.25 2.5ZM9.25 14.5C12.1502 14.5 14.5 12.1502 14.5 9.25C14.5 6.349 12.1502 4 9.25 4C6.349 4 4 6.349 4 9.25C4 12.1502 6.349 14.5 9.25 14.5ZM15.6137 14.5532L17.7355 16.6742L16.6742 17.7355L14.5532 15.6137L15.6137 14.5532Z"/>
      </svg>
    </button>

    <!-- Export CSV Button (somente na tela de pacientes) -->
    

    <!-- Header Button -->
    <button
      *ngIf="headerButton"
      (click)="onHeaderButtonClick()"
      class="px-2 sm:px-3 py-2 bg-westetics-purple-800 text-white hover:bg-westetics-purple-700 transition rounded-lg text-xs sm:text-sm flex items-center gap-1"
    >
    <!-- Ícone de voltar -->
      <svg
        *ngIf="headerButton.action === 'back'"
        class="w-4 h-4"
        viewBox="0 0 20 20"
        fill="currentColor"
      >
        <path d="M12.5 4.5L7 10l5.5 5.5-1.5 1.5L4 10l7-7 1.5 1.5z"/>
      </svg>

      <!-- Ícone de criar -->
      <svg
        *ngIf="headerButton.action === 'create'"
        class="w-4 h-4"
        viewBox="0 0 20 20"
        fill="currentColor"
      >
        <path d="M9.25 9.25V4.75H10.75V9.25H15.25V10.75H10.75V15.25H9.25V10.75H4.75V9.25H9.25Z"/>
      </svg>

      <span class="hidden sm:inline">{{ headerButton.label }}</span>
    </button>

    <!-- Botão Salvar (apenas no modo de edição de empresa) -->
    <button
      *ngIf="showSaveButton"
      (click)="onSaveClick()"
      class="px-2 sm:px-3 py-2 bg-westetics-purple-800 text-white hover:bg-westetics-purple-700 transition rounded-lg text-xs sm:text-sm flex items-center gap-1"
    >
      <!-- Ícone de salvar -->
      <svg
        class="w-4 h-4"
        viewBox="0 0 20 20"
        fill="currentColor"
      >
        <path d="M3 3h11.586L17 5.414V17H3V3zm2 2v10h10V6.414L13.586 5H5z"/>
        <path d="M7 7h4v2H7V7zm0 4h6v4H7v-4z"/>
      </svg>
      <span class="hidden sm:inline">Salvar</span>
    </button>

    <button
      *ngIf="showExportButton"
      (click)="onExportClick()"
      [disabled]="isExporting"
      class="px-2 sm:px-3 py-2 bg-westetics-purple-800 text-westetics-white hover:bg-westetics-purple-700 transition rounded-lg text-xs sm:text-sm flex items-center gap-1 sm:gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
    >
      <!-- Export Icon -->
      <svg
        class="w-4 h-4"
        viewBox="0 0 20 20"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M3 14.5V17H17V14.5H18.5V17C18.5 17.8284 17.8284 18.5 17 18.5H3C2.17157 18.5 1.5 17.8284 1.5 17V14.5H3ZM10.75 12.1893L14.4697 8.46967L15.5303 9.53033L10 15.0607L4.46967 9.53033L5.53033 8.46967L9.25 12.1893V1.5H10.75V12.1893Z"/>
      </svg>
      <span *ngIf="!isExporting" class="hidden sm:inline">Exportar CSV</span>
      <span *ngIf="isExporting" class="hidden sm:inline">Exportando...</span>
    </button>

  </div>

</div>

<!-- Mobile Search Overlay -->
<div
  *ngIf="showSearchField && showMobileSearch"
  class="sm:hidden w-full bg-white border-b px-3 py-2 flex items-center gap-2"
>
  <svg class="w-5 h-5 text-neutral-400 flex-shrink-0" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
    <path d="M9.25 2.5C12.976 2.5 16 5.524 16 9.25C16 12.976 12.976 16 9.25 16C5.524 16 2.5 12.976 2.5 9.25C2.5 5.524 5.524 2.5 9.25 2.5ZM9.25 14.5C12.1502 14.5 14.5 12.1502 14.5 9.25C14.5 6.349 12.1502 4 9.25 4C6.349 4 4 6.349 4 9.25C4 12.1502 6.349 14.5 9.25 14.5ZM15.6137 14.5532L17.7355 16.6742L16.6742 17.7355L14.5532 15.6137L15.6137 14.5532Z"/>
  </svg>
  <input
    #mobileSearchInput
    type="text"
    placeholder="Pesquisar..."
    [(ngModel)]="searchInputValue"
    class="flex-1 h-10 border border-neutral-300 rounded-lg px-3 text-base focus:outline-none focus:ring-2 focus:ring-westetics-purple-300"
    (input)="onSearchInput($event)"
  />
  <button
    type="button"
    (click)="closeMobileSearch()"
    class="p-2 text-neutral-500 hover:text-neutral-700 flex-shrink-0"
  >
    <svg class="w-5 h-5" viewBox="0 0 20 20" fill="currentColor">
      <path d="M6.28 5.22a.75.75 0 00-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 101.06 1.06L10 11.06l3.72 3.72a.75.75 0 101.06-1.06L11.06 10l3.72-3.72a.75.75 0 00-1.06-1.06L10 8.94 6.28 5.22z"/>
    </svg>
  </button>
</div>
